module.exports = __webpack_public_path__ + "static/media/gg.600522e6.svg";